import '@fontsource/ibm-plex-sans-arabic/400.css';
import '@fontsource/ibm-plex-sans-arabic/500.css';
import '@fontsource/ibm-plex-sans-arabic/600.css';
import '@fontsource/ibm-plex-sans-arabic/700.css';
import './styles.css';
import { tokensToCss } from '@bloom/tokens';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router';
import { garrabhaTokens } from '../../brand/tokens';
import { AppProviders } from './app/providers';
import { routes } from './app/routes';

// Garrabha brand tokens (products/garrabha/brand/tokens.ts) override the default `--bl-*`
// values the design system ships. Same generator `pnpm tokens:css` uses, applied at startup.
const brand = document.createElement('style');
brand.dataset.brand = 'garrabha';
brand.textContent = tokensToCss(garrabhaTokens);
document.head.append(brand);

const router = createBrowserRouter(routes);
const root = document.getElementById('root');
if (!root) throw new Error('Missing #root');

createRoot(root).render(
  <StrictMode>
    <AppProviders>
      <RouterProvider router={router} />
    </AppProviders>
  </StrictMode>,
);
